import { CountriesCurrenciesService } from "./../../countries-currencies/countries-currencies.service";
import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import {MatDialog as MatDialog,MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { OrderService } from "../orders/order-service/order.service";
import { OrganizationService } from "src/app/organization-management/organization-service.service";


export enum AdvanceSearchDialogTypes {
  UsersPlans = 1,
  UserPlans = 2,
  UserBookings = 3,
  UserBillings = 4,
  SubmittedForm = 5,
  Currency = 6,
  Organization = 7,
  Site=8
}
@Component({
  selector: "app-advance-search-dialog",
  templateUrl: "./advance-search-dialog.component.html",
  styleUrls: ["./advance-search-dialog.component.css"],
})
export class AdvanceSearchDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AdvanceSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orderService: OrderService,
    private organizationService:OrganizationService,
    private countriesCurrenciesService: CountriesCurrenciesService
  ) {}
  public selectedDate: any;
  public selectedForm: FormGroup;
  public lastPaymentDate: any;
  public startDate: any;
  public nextPaymentDate: any;
  public reservationDate: any;
  public orderDate: any;
  public submitDate: any;
  public orderStatus: any[] = [];
  public sendEmailStatus: any[] = [];
  public cultures: any[] = [];

  public dialogType: AdvanceSearchDialogTypes;
  public usersPlansFilterForm = new FormGroup({
    name: new FormControl(""),
    nextStatusDateFrom: new FormControl(""),
    nextStatusDateTo: new FormControl(""),
    currentStatus: new FormControl(""),
  });
  public userPlansFilterForm = new FormGroup({
    planName: new FormControl(""),
    lastPaymentDateFrom: new FormControl(""),
    lastPaymentDateTo: new FormControl(""),
    nextPaymentDateFrom: new FormControl(""),
    nextPaymentDateTo: new FormControl(""),
    startDateFrom: new FormControl(""),
    startDateTo: new FormControl(""),
    planType: new FormControl(""),
    currentStatus: new FormControl(""),
  });
  public userBookingsFilterForm = new FormGroup({
    name: new FormControl(""),
    reservationDateFrom: new FormControl(""),
    reservationDateTo: new FormControl(""),
    currentStatus: new FormControl(""),
  });
  public billingsFilterForm = new FormGroup({
    stringSearch: new FormControl(""),
    orderDateFrom: new FormControl(""),
    orderDateTo: new FormControl(""),
    orderStatus: new FormControl(""),
  });
  public submittedFilterForm = new FormGroup({
    stringSearch: new FormControl(""),
    submitDateFrom: new FormControl(""),
    submitDateTo: new FormControl(""),
    sendEmailStatus: new FormControl(""),
    submittersendEmailStatus: new FormControl(""),
  });

  public countryCurrencyForm = new FormGroup({
    currencyName: new FormControl(""),
    currencyCulture: new FormControl(""),
  });
  public organizationFiltterForm = new FormGroup({
    currentStatus: new FormControl(""),
  });
  ngOnInit() {
    this.dialogType = this.data.type;
    if (this.dialogType == AdvanceSearchDialogTypes.UsersPlans) {
      this.selectedForm = this.usersPlansFilterForm;
    }
    if (this.dialogType == AdvanceSearchDialogTypes.UserPlans) {
      this.selectedForm = this.userPlansFilterForm;
    }
    if (this.dialogType == AdvanceSearchDialogTypes.UserBookings) {
      this.selectedForm = this.userBookingsFilterForm;
    }
    if (this.dialogType == AdvanceSearchDialogTypes.UserBillings) {
      this.selectedForm = this.billingsFilterForm;
      this.getOrderStatus();
    }
    if (this.dialogType == AdvanceSearchDialogTypes.SubmittedForm) {
      this.selectedForm = this.submittedFilterForm;
    }
    if (this.dialogType == AdvanceSearchDialogTypes.Currency) {
      this.selectedForm = this.countryCurrencyForm;
      this.getAllCultures();
    }
    if (this.dialogType == AdvanceSearchDialogTypes.Organization) {
      this.selectedForm = this.organizationFiltterForm;
    }
    this.lastPaymentDate = { startDate: null, endDate: null };
    this.startDate = { startDate: null, endDate: null };
    this.nextPaymentDate = { startDate: null, endDate: null };
    this.selectedDate = { startDate: null, endDate: null };
    this.reservationDate = { startDate: null, endDate: null };
    this.orderDate = { startDate: null, endDate: null };
    this.submitDate = { startDate: null, endDate: null };
  }
  public getOrderStatus() {
    this.orderService.getOrderStatus().subscribe((result: any) => {
      this.orderStatus = result;
    });
  }

  


  public getAllCultures() {
    this.countriesCurrenciesService.getUsedCulturs().subscribe((res: any) => {
      this.cultures = res;
    });
  }

  public lastPaymentDateChanged() {
    if (this.lastPaymentDate.startDate && this.lastPaymentDate.endDate) {
      this.getFormControlByName(
        this.userPlansFilterForm,
        "lastPaymentDateFrom"
      ).setValue(this.lastPaymentDate.startDate.toDate().toLocaleDateString());
      this.getFormControlByName(
        this.userPlansFilterForm,
        "lastPaymentDateTo"
      ).setValue(this.lastPaymentDate.endDate.toDate().toLocaleDateString());
    }
  }
  public startDateChanged() {
    if (this.startDate.startDate && this.startDate.endDate) {
      this.getFormControlByName(
        this.userPlansFilterForm,
        "startDateFrom"
      ).setValue(this.startDate.startDate.toDate().toLocaleDateString());
      this.getFormControlByName(
        this.userPlansFilterForm,
        "startDateTo"
      ).setValue(this.startDate.endDate.toDate().toLocaleDateString());
    }
  }
  public nextPaymentDateChanged() {
    if (this.nextPaymentDate.startDate && this.nextPaymentDate.endDate) {
      this.getFormControlByName(
        this.userPlansFilterForm,
        "nextPaymentDateFrom"
      ).setValue(this.nextPaymentDate.startDate.toDate().toLocaleDateString());
      this.getFormControlByName(
        this.userPlansFilterForm,
        "nextPaymentDateTo"
      ).setValue(this.nextPaymentDate.endDate.toDate().toLocaleDateString());
    }
  }
  public dateChanged() {
    if (this.selectedDate.startDate && this.selectedDate.endDate) {
      this.getFormControlByName(
        this.usersPlansFilterForm,
        "nextStatusDateFrom"
      ).setValue(this.selectedDate.startDate.toDate().toLocaleDateString());
      this.getFormControlByName(
        this.usersPlansFilterForm,
        "nextStatusDateTo"
      ).setValue(this.selectedDate.endDate.toDate().toLocaleDateString());
    }
  }
  public orderDateChanged() {
    if (this.orderDate.startDate && this.orderDate.endDate) {
      this.getFormControlByName(
        this.billingsFilterForm,
        "orderDateFrom"
      ).setValue(this.orderDate.startDate.toDate().toLocaleDateString());
      this.getFormControlByName(
        this.billingsFilterForm,
        "orderDateTo"
      ).setValue(this.orderDate.endDate.toDate().toLocaleDateString());
    }
  }
  public submitDateChanged() {
    if (this.submitDate.startDate && this.submitDate.endDate) {
      this.getFormControlByName(
        this.submittedFilterForm,
        "submitDateFrom"
      ).setValue(this.submitDate.startDate.toDate().toLocaleDateString());
      this.getFormControlByName(
        this.submittedFilterForm,
        "submitDateTo"
      ).setValue(this.submitDate.endDate.toDate().toLocaleDateString());
    }
  }
  public reservationDateChanged() {
    if (this.reservationDate.startDate && this.reservationDate.endDate) {
      this.getFormControlByName(
        this.userBookingsFilterForm,
        "reservationDateFrom"
      ).setValue(this.reservationDate.startDate.toDate().toLocaleDateString());
      this.getFormControlByName(
        this.userBookingsFilterForm,
        "reservationDateTo"
      ).setValue(this.reservationDate.endDate.toDate().toLocaleDateString());
    }
  }
  public getFormControlByName(
    formName: FormGroup,
    controlName: string
  ): FormControl {
    return formName.get(controlName) as FormControl;
  }
  public submit() {
    this.dialogRef.close(this.selectedForm.value);
  }
  public close() {
    this.dialogRef.close();
  }
}
